// Mock data for demo mode - No backend required
// Contains sample LinkedIn posts in Arabic and English

const MOCK_POSTS = {
  english: {
    professional: [
      {
        content: `The biggest career lesson I learned this year?

Your network is not just about who you know.
It's about who knows what you can DO.

Here's what changed everything for me:

1. I stopped collecting connections
2. I started providing value FIRST
3. I documented my expertise publicly
4. I engaged meaningfully, not superficially

The result?
- 3 unexpected job offers
- 2 speaking invitations
- Countless collaboration opportunities

The truth is: visibility creates opportunity.

But visibility without substance is just noise.

Build your reputation through consistent action, not just connections.

What's the best career advice you've received this year?`,
        hashtags: ['#CareerGrowth', '#Networking', '#ProfessionalDevelopment', '#LinkedIn', '#PersonalBrand'],
        wordCount: 98
      },
      {
        content: `I interviewed 50 senior engineers this quarter.

The #1 skill that separated top performers?

It wasn't technical expertise.
It wasn't years of experience.

It was COMMUNICATION.

The best candidates could:
- Explain complex concepts simply
- Admit what they didn't know
- Ask clarifying questions
- Connect technical decisions to business outcomes

Technical skills get you the interview.
Communication skills get you the job.

And here's the thing most people miss:

Communication is a learnable skill.

3 ways to improve starting today:

1. Practice explaining your work to non-technical friends
2. Write about what you're learning (even if no one reads it)
3. Record yourself presenting and review it critically

The engineers who advance fastest aren't always the smartest.
They're the ones who can translate their intelligence into impact.

What communication skill are you working on?`,
        hashtags: ['#Engineering', '#SoftwareEngineering', '#Communication', '#CareerAdvice', '#TechCareers'],
        wordCount: 145
      }
    ],
    motivational: [
      {
        content: `5 years ago, I was rejected from my dream company.

Yesterday, they asked ME to be a keynote speaker at their conference.

Here's what happened in between:

I didn't give up.
I didn't get bitter.
I got BETTER.

Every rejection taught me something:
- Where my skills were lacking
- How to present myself better
- What the market actually values

I tracked every "no" and turned it into fuel.

100+ rejections became:
- A portfolio of improved skills
- A network of people who said "not yet"
- A mindset that couldn't be broken

The company that rejected you today?
They might be recruiting you tomorrow.

But only if you keep growing.

Rejection is redirection, not rejection.

Drop a comment if you've turned a rejection into a success story. Let's celebrate our comebacks!`,
        hashtags: ['#Motivation', '#CareerSuccess', '#Resilience', '#GrowthMindset', '#NeverGiveUp'],
        wordCount: 142
      }
    ],
    educational: [
      {
        content: `The 80/20 rule changed how I work.

Here's how to apply Pareto's Principle to your career:

20% of your tasks create 80% of your results.

Most people work backwards.
They stay busy with the 80% that barely moves the needle.

Instead, try this framework:

STEP 1: List everything you did last week

STEP 2: Circle the 3 things that created the most value

STEP 3: Ask yourself:
"What would happen if I ONLY did these things?"

STEP 4: Protect time for high-impact work

The uncomfortable truth?
Most of our daily tasks could disappear and no one would notice.

But that ONE important project?
That strategic conversation?
That skill you've been putting off?

THAT's your 20%.

High performers don't work more hours.
They work on the right things.

What's in your 20%? Share below!`,
        hashtags: ['#Productivity', '#TimeManagement', '#80/20Rule', '#CareerTips', '#WorkSmarter'],
        wordCount: 147
      }
    ],
    thought_leadership: [
      {
        content: `Unpopular opinion: Remote work isn't about location.

It's about TRUST.

After 4 years leading distributed teams, here's what I've learned:

Companies struggling with remote work don't have a "remote" problem.
They have a management problem.

The same issues existed in the office.
Remote just made them visible.

What actually matters:

1. OUTCOMES over hours
Measure what people deliver, not when they're online.

2. AUTONOMY with accountability
Give people freedom AND clear expectations.

3. COMMUNICATION by design
Don't assume information flows. Create systems for it.

4. CONNECTION with intention
Remote relationships need more effort, not less.

The future isn't fully remote OR fully in-office.

It's organizations that master FLEXIBILITY.

Where do you stand on the remote work debate?`,
        hashtags: ['#RemoteWork', '#FutureOfWork', '#Leadership', '#Management', '#WorkplaceCulture'],
        wordCount: 134
      }
    ],
    storytelling: [
      {
        content: `"You're not senior material."

Those words crushed me 7 years ago.

My manager said it in a performance review.
Casually. Like it was obvious.

I went home and couldn't sleep.

But here's what I did next:

Instead of arguing, I asked:
"What would 'senior material' look like?"

The answer changed everything.

It wasn't about coding skills.
It wasn't about years of experience.

It was about:
- Mentoring others
- Driving projects without being asked
- Thinking beyond my own work

I wrote down those 3 things.
I worked on them for 18 months.

Then I got the promotion.
At a DIFFERENT company.
For 40% more pay.

The lesson?

Sometimes the people who doubt you give you the roadmap.
You just have to be humble enough to listen.

What criticism turned into your greatest growth? Share your story.`,
        hashtags: ['#CareerStory', '#ProfessionalGrowth', '#Leadership', '#Promotion', '#CareerAdvice'],
        wordCount: 152
      }
    ]
  },
  arabic: {
    professional: [
      {
        content: `اكتشفت شيئا مهما في رحلتي المهنية:

النجاح ليس سباقا... بل رحلة.

بعد 10 سنوات في مجال التقنية، هذه اهم الدروس:

1. المهارات التقنية وحدها لا تكفي
2. بناء العلاقات اهم من بناء السيرة الذاتية
3. التعلم المستمر ليس خيارا بل ضرورة
4. الفشل جزء طبيعي من النمو

ما الذي تغير؟

توقفت عن مقارنة نفسي بالاخرين
بدات اركز على تطوير نفسي يوميا
اصبحت اشارك معرفتي بدلا من الاحتفاظ بها

النتيجة؟

فرص لم اكن اتوقعها
علاقات مهنية قوية
راحة نفسية اكبر

ما هو اهم درس تعلمته في مسيرتك المهنية؟

شاركنا في التعليقات!`,
        hashtags: ['#النجاح_المهني', '#تطوير_الذات', '#التقنية', '#ريادة', '#لينكدإن_عربي'],
        wordCount: 95
      },
      {
        content: `سؤال غير حياتي المهنية:

"ما الذي يمكنني تقديمه للاخرين؟"

بدلا من:

"ما الذي يمكنني الحصول عليه؟"

هذا التحول البسيط فتح ابوابا لم اتخيلها.

كيف طبقت هذا؟

- بدات اشارك خبراتي على LinkedIn
- ساعدت زملائي دون انتظار مقابل
- قدمت نصائح مجانية للمبتدئين في مجالي

ماذا حدث؟

- تواصل معي مديرون للعمل في شركاتهم
- دعيت للتحدث في مؤتمرات
- بنيت سمعة قوية في مجالي

القاعدة الذهبية:

كلما اعطيت اكثر... عاد اليك اكثر.

لكن بشرط واحد: ان يكون العطاء صادقا.

ما هي الطريقة التي تقدم بها قيمة للاخرين؟`,
        hashtags: ['#القيادة', '#النمو_المهني', '#العطاء', '#النجاح', '#تطوير'],
        wordCount: 112
      }
    ],
    motivational: [
      {
        content: `قبل 3 سنوات كنت على وشك الاستسلام.

رفضوني 27 مرة.
27 "لا" متتالية.

لكنني لم اتوقف.

ما الذي ابقاني مستمرا؟

فهمت ان كل رفض هو درس:
- الرفض الاول علمني تحسين سيرتي الذاتية
- الرفض العاشر علمني مهارات المقابلات
- الرفض العشرون علمني الصبر

واليوم؟

اعمل في الشركة التي كنت احلم بها.
براتب افضل مما توقعت.
في منصب لم اكن اتخيله.

الدرس؟

الرفض ليس نهاية الطريق.
الرفض هو جزء من الطريق.

كل "لا" تقربك من "نعم" الصحيحة.

لكن بشرط واحد: ان تستمر في المحاولة.

من واجه رفضا وتحول الى نجاح؟

شاركنا قصتك!`,
        hashtags: ['#تحفيز', '#نجاح', '#لا_تستسلم', '#قصص_نجاح', '#الاصرار'],
        wordCount: 118
      }
    ],
    educational: [
      {
        content: `خطا يقع فيه 90% من الموظفين:

ينتظرون ان يلاحظهم المدير.

الحقيقة الصعبة؟

لا احد سيبحث عنك.
عليك ان تجعل نفسك مرئيا.

كيف؟

1. وثق انجازاتك
لا تعتمد على ذاكرة مديرك.
سجل كل مشروع ناجح.
كل مشكلة حللتها.
كل نتيجة حققتها.

2. شارك عملك
في الاجتماعات، تحدث عن انجازاتك.
ليس تفاخرا... بل توضيحا.

3. اطلب التغذية الراجعة
لا تنتظر التقييم السنوي.
اسال بشكل دوري: "كيف يمكنني التحسن؟"

4. ابني علاقات
ليس فقط مع مديرك.
مع زملائك وفرق اخرى.

النتيجة؟

عندما تاتي فرصة الترقية...
ستكون اول من يتذكرونه.

ما هي نصيحتك للحصول على ترقية؟`,
        hashtags: ['#نصائح_مهنية', '#الترقية', '#تطوير_المهارات', '#العمل', '#النجاح_الوظيفي'],
        wordCount: 128
      }
    ],
    thought_leadership: [
      {
        content: `راي قد لا يعجب الكثيرين:

الشهادات الجامعية لم تعد كافية.

دعوني اوضح:

لا اقول انها غير مهمة.
لكنها اصبحت الحد الادنى.

ما الذي يميزك اليوم؟

1. المهارات العملية
ما تستطيع فعله > ما تعرفه نظريا

2. التعلم المستمر
العالم يتغير بسرعة.
من لا يتعلم... يتخلف.

3. الشبكة المهنية
الفرص تاتي من العلاقات اكثر من التقديم التقليدي.

4. المشاريع الشخصية
اعمال جانبية.
محتوى تنشره.
مساهمات في مجتمعك.

السوق اليوم يسال:

"ماذا فعلت؟"
وليس فقط "ماذا درست؟"

هل توافقني الراي؟

ام ان الشهادة لا تزال الاهم؟`,
        hashtags: ['#سوق_العمل', '#المهارات', '#التعليم', '#التوظيف', '#راي'],
        wordCount: 115
      }
    ],
    storytelling: [
      {
        content: `قصة غيرت نظرتي للفشل:

في 2019، اطلقت مشروعي الاول.

استثمرت فيه:
- كل مدخراتي
- 18 شهرا من العمل
- حلمي الكبير

بعد 6 اشهر... اغلقته.

فشل كامل.

شعرت بالخزي.
اختفيت من السوشيال ميديا.
كدت اترك ريادة الاعمال نهائيا.

لكن صديقا قال لي شيئا غير كل شيء:

"انت لم تفشل... انت تعلمت"

بدات انظر للتجربة بشكل مختلف:

- تعلمت ادارة المال
- فهمت السوق بشكل اعمق
- بنيت علاقات ستفيدني لاحقا

اليوم؟

مشروعي الثاني ناجح.
وكل نجاحه مبني على فشل الاول.

الفشل ليس نهاية.
الفشل هو بداية مختلفة.

ما هو اكبر فشل تحول الى درس في حياتك؟`,
        hashtags: ['#ريادة_الاعمال', '#قصتي', '#الفشل', '#النجاح', '#دروس_الحياة'],
        wordCount: 132
      }
    ]
  },
  mixed: {
    professional: [
      {
        content: `Something I learned after 8 years in tech:

المهارات التقنية تفتح الباب.
But soft skills keep you in the room.

Here's what I mean:

في بداية مسيرتي، ركزت فقط على البرمجة.
I was the best coder on my team.
لكنني لم احصل على ترقية لسنتين.

Why?

Because I couldn't:
- اشرح افكاري بوضوح
- Work effectively with non-technical teams
- ابني علاقات مع الادارة

The shift happened when I realized:

Technical excellence is expected.
Connection is what elevates you.

Now I spend 30% of my time on relationships.
والنتيجة؟ فرص لم اكن اتخيلها.

What skill do you think is most underrated in tech?

ما المهارة التي تعتقد انها لا تحظى بالاهتمام الكافي؟`,
        hashtags: ['#Tech', '#التقنية', '#SoftSkills', '#CareerGrowth', '#مهارات'],
        wordCount: 135
      }
    ]
  }
};

const MOCK_HASHTAGS = {
  english: {
    technology: ['#Tech', '#AI', '#MachineLearning', '#Programming', '#Innovation', '#Digital'],
    business: ['#Business', '#Entrepreneurship', '#Startup', '#Leadership', '#Strategy', '#Growth'],
    career: ['#CareerAdvice', '#JobSearch', '#ProfessionalDevelopment', '#Networking', '#Success'],
    marketing: ['#Marketing', '#DigitalMarketing', '#Branding', '#ContentMarketing', '#SocialMedia'],
    personal: ['#Productivity', '#Motivation', '#GrowthMindset', '#Learning', '#PersonalBrand']
  },
  arabic: {
    technology: ['#تقنية', '#ذكاء_اصطناعي', '#برمجة', '#تكنولوجيا', '#ابتكار'],
    business: ['#ريادة', '#اعمال', '#شركات_ناشئة', '#قيادة', '#نجاح'],
    career: ['#مسيرة_مهنية', '#توظيف', '#تطوير_مهني', '#وظائف', '#نصائح_مهنية'],
    marketing: ['#تسويق', '#تسويق_رقمي', '#محتوى', '#سوشيال_ميديا'],
    personal: ['#انتاجية', '#تحفيز', '#تطوير_الذات', '#تعلم', '#نمو']
  }
};

const MOCK_IMAGE_PROMPTS = [
  `Professional business concept visualization with clean geometric shapes, modern gradient from deep blue to teal, minimalist corporate aesthetic, 3D rendered abstract forms representing growth and innovation, soft studio lighting, 8k quality, LinkedIn-optimized aspect ratio`,

  `Abstract data visualization with flowing lines and nodes, representing connectivity and digital transformation, deep navy background with glowing cyan accents, futuristic tech aesthetic, clean composition, professional business imagery, ultra-detailed, modern corporate style`,

  `Inspiring leadership concept with ascending geometric stairs, warm golden hour lighting, blend of organic and digital elements, representing career growth and success, professional photography style, shallow depth of field, motivational business imagery`
];

// Helper function to generate a unique ID
const generateId = () => Math.random().toString(36).substring(2, 15);

// Simulate network delay for realistic demo experience
const simulateDelay = (min = 800, max = 2000) => {
  const delay = Math.floor(Math.random() * (max - min) + min);
  return new Promise(resolve => setTimeout(resolve, delay));
};

// Get random item from array
const getRandomItem = (arr) => arr[Math.floor(Math.random() * arr.length)];

// Get mock post based on parameters
export const getMockPost = async (params) => {
  await simulateDelay(1000, 2500);

  const { language = 'english', tone = 'professional' } = params;

  // Determine which language pool to use
  let langKey = language;
  if (!MOCK_POSTS[langKey]) {
    langKey = 'english';
  }

  // Determine which tone pool to use
  let toneKey = tone;
  if (!MOCK_POSTS[langKey][toneKey]) {
    toneKey = 'professional';
  }

  const posts = MOCK_POSTS[langKey][toneKey];
  const post = getRandomItem(posts);

  return {
    id: generateId(),
    content: post.content,
    hashtags: post.hashtags,
    wordCount: post.wordCount,
    characterCount: post.content.length,
    language: language,
    tone: tone,
    createdAt: new Date().toISOString()
  };
};

// Get mock refined post
export const getMockRefinedPost = async (originalContent, feedback) => {
  await simulateDelay(1200, 2000);

  // Add some variation to the content based on feedback keywords
  let refinedContent = originalContent;

  if (feedback.toLowerCase().includes('shorter')) {
    // Truncate to about 60% of original
    const sentences = originalContent.split(/[.!?]/);
    const keepCount = Math.ceil(sentences.length * 0.6);
    refinedContent = sentences.slice(0, keepCount).join('. ') + '.';
  } else if (feedback.toLowerCase().includes('longer') || feedback.toLowerCase().includes('more detail')) {
    refinedContent = originalContent + '\n\nRemember: Small consistent steps lead to big results over time.';
  } else {
    // Default: add a slight modification
    refinedContent = originalContent.replace(/\n\n/g, '\n\n(improved) ').replace('(improved) (improved)', '(improved)');
  }

  return {
    content: refinedContent,
    wordCount: refinedContent.split(/\s+/).length,
    characterCount: refinedContent.length,
    refinedAt: new Date().toISOString()
  };
};

// Get mock hashtags
export const getMockHashtags = async (title, content) => {
  await simulateDelay(500, 1000);

  // Detect language from content
  const arabicPattern = /[\u0600-\u06FF]/;
  const isArabic = arabicPattern.test(content);

  const langHashtags = isArabic ? MOCK_HASHTAGS.arabic : MOCK_HASHTAGS.english;

  // Pick random hashtags from different categories
  const categories = Object.keys(langHashtags);
  const selectedHashtags = [];

  categories.forEach(cat => {
    const catHashtags = langHashtags[cat];
    selectedHashtags.push(getRandomItem(catHashtags));
  });

  // Add one or two more random ones
  const allHashtags = Object.values(langHashtags).flat();
  selectedHashtags.push(getRandomItem(allHashtags));

  // Remove duplicates and limit to 6
  const uniqueHashtags = [...new Set(selectedHashtags)].slice(0, 6);

  return uniqueHashtags;
};

// Get mock image prompts
export const getMockImagePrompts = async () => {
  await simulateDelay(800, 1500);

  return MOCK_IMAGE_PROMPTS;
};

// Mock saved posts storage
let savedPosts = [];

export const saveMockPost = async (postData) => {
  await simulateDelay(300, 600);

  const post = {
    id: generateId(),
    ...postData,
    status: 'draft',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  };

  savedPosts.push(post);

  // Also save to localStorage for persistence
  localStorage.setItem('linkedin_demo_saved_posts', JSON.stringify(savedPosts));

  return post;
};

export const getSavedPosts = async () => {
  await simulateDelay(200, 400);

  // Load from localStorage
  const stored = localStorage.getItem('linkedin_demo_saved_posts');
  if (stored) {
    savedPosts = JSON.parse(stored);
  }

  return savedPosts;
};

export const deleteMockPost = async (postId) => {
  await simulateDelay(200, 400);

  savedPosts = savedPosts.filter(p => p.id !== postId);
  localStorage.setItem('linkedin_demo_saved_posts', JSON.stringify(savedPosts));

  return true;
};

export const updateMockPost = async (postId, updates) => {
  await simulateDelay(300, 500);

  const index = savedPosts.findIndex(p => p.id === postId);
  if (index !== -1) {
    savedPosts[index] = {
      ...savedPosts[index],
      ...updates,
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem('linkedin_demo_saved_posts', JSON.stringify(savedPosts));
    return savedPosts[index];
  }

  throw new Error('Post not found');
};

// Demo mode indicator
export const isDemoMode = () => true;

export default {
  getMockPost,
  getMockRefinedPost,
  getMockHashtags,
  getMockImagePrompts,
  saveMockPost,
  getSavedPosts,
  deleteMockPost,
  updateMockPost,
  isDemoMode
};
